import React, { Component } from "react";
import { API } from "aws-amplify";
import axios from 'axios';
import 'react-table/react-table.css';
import 'containers/common/Detail.css';


import PropertyProposalList from "containers/property/PropertyProposalList";
import { LinkContainer } from "react-router-bootstrap";

import { Form, Row, Col, Card, Tabs, Tab, Button, Alert, Nav, Modal } from "react-bootstrap";


import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { css } from '@emotion/core';
import { PacmanLoader } from 'react-spinners';
import Moment from "moment";

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

export default class ProposalDetail extends Component {
    constructor(props) {
        super(props);

        this.updateTableState = this.updateTableState.bind(this);
        this.saveRecord = this.saveRecord.bind(this);        
        this.refreshDataSet = this.refreshDataSet.bind(this);
        this.validateRelatedRecord = this.validateRelatedRecord.bind(this);
        
        

        this.state = {
            isLoading: false,
            isDeleting: null,
            proposalData: null,       
            showAlert: false,
            errorMessage: "",
            modified: false,
            
            idList: [],
            previousId: -1,
            nextId: -1,
            propertyidlist: [],

            areaSum: 0,

            selectedClassification: null,
            classificationOptions: [],

            selectedProposalType: null,
            proposalTypeOptions: [],

            propertyProposals: [],
            propertyFilter: {},
            property_key: this.props.match.params.propertyid,
            property_id: null,
            proposal_id: null, 
            source_date: null,
            file_number: null,
            date_lodged: null,
            approved: null,
            date_approved: null,
            current: null,
            include_in_text: null,
            proceeded: null,
            development_name: null, 
            proposal_type_code: null,
            proposal_type: null,
            classification_code: null,
            classification: null,
            proposal: null,
            notes: null,
            tmp_fld_prop_key: null,
            created_date: null,
            created_by: null,
            last_edited_date: null,
            last_edited_by: null

        };



       

    }

    componentWillReceiveProps(prevProps) {
        
        if (prevProps.location.pathname !== this.props.location.pathname) {
            // Clean component and reload? 
            console.log("Resetting");
            window.location.reload();
        }
    }
    

    componentWillUnmount() {
        source.cancel();
        this.setState({ proposal: [] });
     
    }

  
    async componentDidMount() {
        

        try {
            this.setState({ isLoading: true });   

            if (this.props.match.params.id === "new") {
                console.log("New proposal");
                this.setState(state => ({ property_id: this.props.location.search.replace("?propertyid=", "")  }));
                
                this.setState(state => ({ source_date: new Date() }));
                this.setState(state => ({ current: true }));
                this.setState(state => ({ approved: false }));
                this.setState(state => ({ proceeded: false }));
                this.setState(state => ({ include_in_text: true }));
                this.setState(state => ({ source_date: new Date() }));
                this.setState(state => ({ last_edited_by: this.props.user  }));
                this.setState(state => ({ created_by: this.props.user }));
                await this.syncroniseState();
                document.title = "New proposal for " + this.state.property_key;

            }
            else {

                await this.retrieveProposal();
                if (this.props.location.state){
                    if (this.props.location.state.hasOwnProperty("data")){
                        const idList = this.props.location.state.data;
                        var currentIdIndex = idList.indexOf(parseInt(this.props.match.params.id,10));

                        let nextId = null;
                        let previousId = null;
                        
                        if (currentIdIndex+1 < idList.length){
                            nextId = idList[currentIdIndex+1];
                            
                        }
                        if (currentIdIndex >0){
                            previousId = idList[currentIdIndex-1];                            
                        }
                        this.setState({idList: idList,nextId: nextId, previousId: previousId, currentIdIndex: currentIdIndex});
                    }

                    if (this.props.location.state.propertyidlist){
                        this.setState({propertyidlist: this.props.location.state.propertyidlist});
                    }

                }
                this.setState(state => ({ propertyFilter: { proposalid: this.state.proposal_id } }))

                try {
                    await this.getProperties(this.state.propertyFilter);
                    let areaSum = 0
                    if(this.state.propertyProposals.length>0){
                        for (let i = 0; i < this.state.propertyProposals.length; i++) {
                            
                            if (this.state.propertyProposals[i].hasOwnProperty('site_area')){
                                if (this.state.propertyProposals[i].site_area != null){
                                    areaSum += this.state.propertyProposals[i].site_area
                                }
                            }
                        }
                        this.setState({areaSum});
                    }
                }
                catch{
                    alert("Error loading properties");
                }
                document.title = this.state.proposal_id;

            }
            
            

            //Get lookups
            this.setState({ selectedClassification: { value: this.state.classification_code, label: this.state.classification } });
            await this.getClassifications();


            this.setState({ selectedProposalType: { value: this.state.proposal_type_code, label: this.state.proposal_type } });
            await this.getProposalTypes();


            




            
            this.setState({ isLoading: false });   
        } catch (e) {
            alert(e);
        }
    }



    async syncroniseState() {

        const proposalData = {
            proposal_id: this.state.proposal_id,
            source_date: this.state.source_date,
            file_number: this.state.file_number,
            date_lodged: this.state.date_lodged,
            approved: this.state.approved,
            date_approved: this.state.date_approved,
            current: this.state.current,
            include_in_text: this.state.include_in_text,
            proceeded: this.state.proceeded,
            development_name: this.state.development_name,
            proposal_type_code: this.state.proposal_type_code,
            proposal_type: this.state.proposal_type,
            classification_code: this.state.classification_code,
            classification: this.state.classification,
            proposal: this.state.proposal,
            notes: this.state.notes,
            tmp_fld_prop_key: this.state.tmp_fld_prop_key,
            created_date: this.state.created_date,
            created_by: this.state.created_by,
            last_edited_date: this.state.last_edited_date,
            last_edited_by: this.state.last_edited_by,
            archived_date: this.state.archived_date
        };

        this.setState({ proposalData });
        return true
    }



    async retrieveProposal() {
        const proposalData = await this.getProposal();

        const {
            proposal_id,
            source_date,
            file_number,
            date_lodged,
            approved,
            date_approved,
            current,
            include_in_text,
            proceeded,
            development_name,
            proposal_type_code,
            proposal_type,
            classification_code,
            classification,
            proposal,
            notes,
            tmp_fld_prop_key,
            created_date,
            created_by,
            last_edited_date,
            last_edited_by } = proposalData;

        this.setState({
            proposalData,
            proposal_id,
            source_date,
            file_number,
            date_lodged,
            approved,
            date_approved,
            current,
            include_in_text,
            proceeded,
            development_name,
            proposal_type_code,
            proposal_type,
            classification_code,
            classification,
            proposal,
            notes,
            tmp_fld_prop_key,
            created_date,
            created_by,
            last_edited_date,
            last_edited_by
        });


    }


    //Call API

    getProposal() {
        try {
            const result = API.get("colin", `/proposals/${this.props.match.params.id}`, { 'cancelToken': source.token });
            return result
        }
        catch{
            console.log("Error getting the proposal");
        }
        
    }

    async saveProposal(proposal) {

        proposal.last_edited_by= this.props.user;
        if (this.props.match.params.id === "new" && this.state.proposal_id === null) {
            this.setState({ created_by: this.props.user });
            const response =  await API.post("colin", `/proposals/new`, { body: proposal });
            try {
                return await response;
    
            } catch (error) {
                alert(error+". Please refresh the page (F5) to try again.")
            };
        }
        const response =  API.put("colin", `/proposals/${this.state.proposal_id}`, {  body: proposal });
        try {
            return await response;

        } catch (error) {
            alert(error+". Please refresh the page (F5) to try again.")
        };
    }





    async getProperties(filter) {
        try {
            return API.get("colin", "/propertyproposals", { 'queryStringParameters': filter, 'cancelToken': source.token }).then((propertyProposals) => {
                if (propertyProposals) {
                    this.setState(state => ({ propertyProposals }));
                }
            });
        }
        catch{
            console.log("Error getting proposals");
        }
    }
   
    getClassifications() {
        try {
            API.get("colin", `/classifications`, { 'cancelToken': source.token }).then((classificationOptions) => {
                if (classificationOptions) {
                    this.setState(state => ({ classificationOptions }));
                }
            });
        }
        catch{
            console.log("Error getting classifications");
        }
    }

    getProposalTypes() {
        try {
            API.get("colin", `/proposaltypes`, { 'cancelToken': source.token }).then((proposalTypeOptions) => {
                if (proposalTypeOptions) {
                    this.setState(state => ({ proposalTypeOptions }));
                }
            });
        }
        catch{
            console.log("Error getting proposal types");
        }
    }

  

    handleEnterCurrentIdIndex = event =>{
        if(event.keyCode === 13 || event.keyCode === 9 ){
           this.handleGoToRecord();
        }
   }



    handleGoToRecord = event => {
        console.log(this.state.idList.length);
        if(this.state.currentIdIndex>=0 && this.state.currentIdIndex < this.state.idList.length){
            this.props.history.push({pathname:`/properties/${this.state.property_key}/${this.state.idList[this.state.currentIdIndex]}`, state:{data: this.state.idList, propertyidlist: this.state.propertyidlist}});
        }
        else{
            alert("Page no not in range.");
        }
    }

    handleCurrentIdIndexChange =event =>{
        const val = event.target.value.replace(/[^0-9.]/g, "");
        this.setState({[event.target.id]: val-1});        
    }

    refreshDataSet = async (dataset) => {
        //Get nabers records
        
    }

    
    validateRelatedRecord(record, set) {
        //property
        if (set === "proposal") {

            // secondly check that UnitSort has been specified if required
            
            if (!this.state.proposal) {
                return [false, "Proposal text can't be null. The record has not been saved."];
            }

            if (this.state.current && this.state.proceeded) {
                return [false, "The proposal cannot be current and also went ahead. Current flag has been cleared."];
            }

            if (this.state.include_in_text && this.state.proceeded) {
                return [false, "The proposal cannot be included in text when it went ahead. Include in text has been cleared."];
            }
            
        }

        if (set === "propertyProposals") {

            // secondly check that UnitSort has been specified if required

            if (!record.property_key) {
                return [false, "Enter a Cityscope reference."];
            }


        }



        return [true,];
    }

    updateTableState(data, set) {
        this.setState({
            [set]: data
        });
    }

    saveRecord(record, endpoint, id) {

        record.last_edited_by = this.props.user;
        //If the record is a new record perform a post
        if (record.hasOwnProperty("new_record")) {
            if (record.new_record === true) {
                record.last_edited_by = this.props.user;
                return API.post("colin", `/${endpoint.toLowerCase()}/new`, {
                    body: record
                });
            }
        }
        //If not a new record and updating an existing, perform a put
        return API.put("colin", `/${endpoint.toLowerCase()}/${record[id]}`, {
            body: record
        }
        );
    }

    

   



    handleClassificationChange = (selectedClassification) => {
        this.setState({ selectedClassification
                    , classification_code: selectedClassification.value 
                    , modified: true },this.handleBlur);
        
    }

    handleProposalTypeChange = (selectedProposalType) => {
        this.setState({ selectedProposalType
                    ,proposal_type_code: selectedProposalType.value 
                    , modified: true },this.handleBlur);
        
    }
 
   
   

    
    handleChange = event => {
        this.setState({[event.target.id]: event.target.value });
        this.setState({ modified: true });
        

        
    }

    handlePercentChange = event => {
        let val = event.target.value.replace(/[^0-9.%]/g, "");
        this.setState({
            [event.target.id]: val
        });
        this.setState({ modified: true });
    }

    handleNumberChange = event => {
        let val = event.target.value.replace(/[^0-9.]/g, "");
        this.setState({
            [event.target.id]: val
        });
        this.setState({ modified: true });
    }

 

    handleDateChange(date, name) {
        var options = {  year: 'numeric', month: 'long', day: 'numeric' };
        var dt = new Date(date);
        
        if (date) {
            this.setState({
                [name]: dt.toLocaleDateString('en-AU',options)
                , modified: true
            });
        }
        else {
            this.setState({
                [name]: null
                , modified: true });
        }
        
    }



    handleCheckBoxChange = event => {
        
        let name = event.target.name
        this.setState({
            [name]: event.target.checked
            , modified: true },this.handleBlur)
        
        if(name==="proceeded"){
            if(event.target.checked){
                alert("You have selected that the proposal is completed so the current and include in text flags have been set to false");
                this.setState({current: false,
                    include_in_text: false,
                    approved: true});
            }
        }
        if(name==="current" || name==="include_in_text"){
            if(event.target.checked){
                if(this.state.proceeded){ 
                    alert("The proposal was completed but you selected that it is current or to include in text. The completed flag has been set to false");
                    this.setState({proceeded: false,
                        [event.target.name]: event.target.checked});
                }
                else{
                    this.setState({[event.target.name]: event.target.checked});
                }
            }
        }

   

    }
    
    async addPropertyRelation(proposalId) {
        let data = [...this.state.propertyProposals];

        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        data.push({
            property_id: this.state.property_id,
            property_key: this.state.property_key,
            proposal_id: proposalId,
            alternate_text: "",
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true

        });
        this.updateTableState(data, "propertyProposals");
        const result = await this.saveRecord(data[0], "propertyProposals", "property_proposal_id");
        if (result.result) {            
            data[0].property_proposal_id = result.id;
            data[0].new_record = false;
            this.updateTableState(data, "propertyProposals");
        }
        else {
            this.setState({ errorMessage: result.error_message });
            this.setState({ showAlert: true });
        }

        return;
    }
    
    handleBlur = async event => {
        console.log("In proposal handle blur")
        if (this.state.modified === true) {
            this.setState({ showAlert: false, last_edited_by: this.props.user });
            await this.syncroniseState();
           


            const validation = this.validateRelatedRecord(this.state.proposalData, "proposalData");
            console.log(validation)
            if (validation[0] === true) {
                try {
                    this.setState(state => ({ modified: false }));
                    if (this.props.match.params.id === "new") {
                        this.setState({ isLoading: true });
                    }
                    console.log("Saving proposal");
                    const result = await this.saveProposal(this.state.proposalData);
                    console.log(result);
                    this.setState({ isLoading: false });
                    if (result.result === false) {
                        alert(result.error_message);
                    }
                    else {
                        if (this.props.match.params.id === "new") {
                            this.setState(state => ({ proposal_id: result.id }));
                            //Create relation to property
                            await this.addPropertyRelation(result.id);
                            this.props.history.push("/proposals/" + this.state.proposal_id);
                        }
                    }



                } catch (e) {
                    alert(e);

                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
            }

        }

        }



    handleDelete = async event => {
        event.preventDefault();
        if (event.detail !== 0) {
            if (!this.state.registered) {
                const confirmed = window.confirm(
                    "Are you sure you want to delete this proposal?"
                );

                if (!confirmed) {
                    return;
                }
                else {
                    this.setState({ archived_date: new Date() }, () =>
                        this.syncroniseState().then(async () => {
                            const result = await this.saveProposal(this.state.proposalData);
                            if (result.result === false) {
                                alert(result.error_message);
                            }
                            else {
                                const deletedProposalId = this.state.proposalData.proposal_id;
                                const remainingIds = this.state.idList.filter(id => id !== deletedProposalId);

                                if (this.state.nextId && this.state.nextId > 0) {
                                    this.props.history.push(`/properties/${this.state.property_key}/proposals/${this.state.nextId}`, {data: remainingIds, propertyidlist: this.state.propertyidlist});
                                } else if (remainingIds.length > 0) {
                                    this.props.history.push(`/properties/${this.state.property_key}/proposals/${remainingIds[remainingIds.length - 1]}`,{data: remainingIds, propertyidlist: this.state.propertyidlist});
                                } else {
                                    this.props.history.push(`/properties/${this.state.property_key}`);
                                }
                            }
                        }
                        )
                    );

                }

            }
            else {
                window.alert("Proposal records cannot be deleted");
            }
        }
    }


 
    

    render() {
        return (
            <div className="Proposal">
                {this.state.isLoading &&
                <div className="outer-div"><div className='sweet-loading inner-div' >
                    <PacmanLoader
                        css={css`
                        display: block;
                        margin: 0 auto;
                        border-color: red`}
                        sizeUnit={"px"}
                        size={20}
                        color={'#e03c31'}
                        loading={this.state.isLoading}
                    />
                </div> 
                    </div>}
               
              
                {this.state.proposalData && this.props.isAuthenticated && !this.state.isLoading &&
                    <div className="PropertyForm">
                    

                        <Row><Col sm={4} md={4} lg={4}>
                            {/*  {this.state.propertyProposals && <LinkContainer to={`/properties/${this.state.propertyProposals[0].property_key}`} ><Button variant="primary">Back to Property {this.state.propertyProposals[0].property_key}</Button></LinkContainer>}*/}
                     </Col> 
                    
                        <Col>
                                <Nav className="justify-content-center" >
                                {this.state.previousId !== null && this.state.idList.length>0 &&
                                    <Nav.Item  >
                                        <LinkContainer to={{pathname:`/properties/${this.state.property_key}/proposals/${this.state.previousId}`, state:{data: this.state.idList, propertyidlist: this.state.propertyidlist}}} >
                                            <Button type="button" variant="info"  size="sm">Previous</Button></LinkContainer>{" "}
                                    </Nav.Item>}
                                    {this.state.nextId !== null && this.state.idList.length>0 &&
                                    <Nav.Item  >
                                        <LinkContainer to={{pathname:`/properties/${this.state.property_key}/proposals/${this.state.nextId}`, state:{data: this.state.idList, propertyidlist: this.state.propertyidlist}}} >
                                            <Button type="button" variant="info"  size="sm">Next</Button></LinkContainer>{" "}
                                    </Nav.Item>}
                                    {this.state.currentIdIndex!==null && this.state.idList.length>0 &&
                                        <Form.Group as={Row} controlId="currentIdIndex" >     
                                        <Col className="zeroPadRight">
                                            <Form.Control
                                                onChange={this.handleCurrentIdIndexChange}
                                                value={this.state.currentIdIndex+1}
                                                as="input"
                                                type="text"
                                                min="0"
                                                className="pageCount"
                                                onBlur={this.handleGoToRecord}
                                                onKeyDown={this.handleEnterCurrentIdIndex}
                                            />
                                            </Col>                               
                                            <Col  className="zeroPadLeft">
                                            <h6><div className="topPad">of {this.state.idList.length} {" "}</div></h6>
                                            </Col>
                                            
                                        </Form.Group>
                                         
                                    }
                                    </Nav>
                                </Col>
                        <Col  >
                        <Nav className="justify-content-end" >
                        {this.state.property_key &&
                                <Nav.Item  >
                                        <LinkContainer to={ {pathname: `/properties/${this.state.property_key}`, state: {tab: "proposals", data: this.state.propertyidlist}}} >
                                            <Button type="button" variant="primary"  size="sm">Back to Property {this.state.property_key}</Button></LinkContainer>{" "}
                                    </Nav.Item>
                                }
                                    
                            <Nav.Item  >
                            <Button
                                variant="danger"
                                onClick={this.handleDelete}
                                type="button"
                                size="sm"
                            >Delete</Button>
                            </Nav.Item>
                            </Nav>
                        </Col>
                        </Row>
                    <Form  >
                    <Row  id="detail">
                            <Col>
                            <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                                <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                                <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                            </Modal>
                                <Tabs defaultActiveKey={0} id="tabset">
                                <Tab eventKey={0} title="Proposal Detail">
                        <Card >
                              

                                
                                    <Card.Body>
                                            
       

                                    <Form.Row >
                                           
                                            <Col sm={12} md={6} lg={3}>

                                                <Card >

                                                    <Card.Body>
                                                        <Form.Group as={Row} controlId="proposal_id" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Proposal ID</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.proposal_id}
                                                                    as="input"
                                                                    type="text"
                                                                    readOnly

                                                                />
                                                            </Col>

                                                        </Form.Group>

                                                        <Form.Group as={Row} controlId="source_date" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Source Date</Form.Label>
                                                            <Col>
                                                                <DatePicker
                                                                    selected={new Date(this.state.source_date)}
                                                                    onChange={e => this.handleDateChange(e, "source_date")}
                                                                    className="form-control"
                                                                    onBlur={this.handleBlur}
                                                                    dateFormat="dd/MM/yyyy"
                                                                />
                                                            </Col>

                                                        </Form.Group>

                                                        <Form.Group as={Row} controlId="file_number" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>LGA File Number</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.file_number}
                                                                    as="input"
                                                                    type="text"
                                                                    onBlur={this.handleBlur}
                                                                />
                                                            </Col>

                                                        </Form.Group>


                                                        <Form.Group as={Row} controlId="date_lodged" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Date Lodged</Form.Label>
                                                            <Col>
                                                                <DatePicker
                                                                    selected={this.state.date_lodged!=null? new Date(this.state.date_lodged): null}
                                                                    onChange={e => this.handleDateChange(e, "date_lodged")}
                                                                    className="form-control"
                                                                    onBlur={this.handleBlur}
                                                                    dateFormat="dd/MM/yyyy"
                                                                />
                                                            </Col>

                                                        </Form.Group>
                                                        

                                                        <Form.Group as={Row} controlId="approved" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Approved</Form.Label>
                                                            <Col>
                                                                <Form.Check checked={this.state.approved}
                                                                    onChange={this.handleCheckBoxChange}
                                                                    label=""
                                                                    type="checkbox"
                                                                    name="approved"
                                                                    onBlur={this.handleBlur}
                                                                />
                                                            </Col>

                                                        </Form.Group>

                                                        <Form.Group as={Row} controlId="date_approved" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Date Approved</Form.Label>
                                                            <Col>
                                                                <DatePicker
                                                                    selected={this.state.date_approved!=null? new Date(this.state.date_approved): null}
                                                                    onChange={e => this.handleDateChange(e, "date_approved")}
                                                                    className="form-control"
                                                                    onBlur={this.handleBlur}
                                                                    dateFormat="dd/MM/yyyy"
                                                                />
                                                            </Col>

                                                        </Form.Group>
                                                        <Row><Col sm={6} md={6} lg={4}></Col><Col>Fill in only where new development or redevelopment</Col></Row>
                                                        <Form.Group as={Row} controlId="development_name" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Development Name</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.development_name}
                                                                    as="input"
                                                                    type="text"
                                                                    onBlur={this.handleBlur}
                                                                />
                                                            </Col>

                                                        </Form.Group>

                                                        <Form.Group as={Row} controlId="classification_code" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Classification</Form.Label>
                                                            <Col>
                                                                <Select
                                                                    value={this.state.selectedClassification}
                                                                    onChange={this.handleClassificationChange}
                                                                    options={this.state.classificationOptions}
                                                                    onBlur={this.handleBlur}
                                                                />
                                                            </Col>

                                                        </Form.Group>


                                                        <Form.Group as={Row} controlId="proposal_type_code" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Proposal Type</Form.Label>
                                                            <Col>
                                                                <Select
                                                                    value={this.state.selectedProposalType}
                                                                    onChange={this.handleProposalTypeChange}
                                                                    options={this.state.proposalTypeOptions}
                                                                    onBlur={this.handleBlur}
                                                                />
                                                            </Col>

                                                        </Form.Group>





                                                    </Card.Body>
                                                </Card>

                                                <Card >

                                                    <Card.Body>
                                                        <Form.Group as={Row} controlId="current" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Still Current</Form.Label>
                                                            <Col>
                                                                <Form.Check checked={this.state.current}
                                                                    onChange={this.handleCheckBoxChange}
                                                                    label=""
                                                                    name="current"
                                                                    type="checkbox"
                                                                    onBlur={this.handleBlur}
                                                                />
                                                            </Col>

                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="include_in_text" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Include In Text</Form.Label>
                                                            <Col>
                                                                <Form.Check checked={this.state.include_in_text}
                                                                    onChange={this.handleCheckBoxChange}
                                                                    label=""
                                                                    type="checkbox"
                                                                    name="include_in_text"
                                                                    onBlur={this.handleBlur}
                                                                />
                                                            </Col>

                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="proceeded" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Proceeded</Form.Label>
                                                            <Col>
                                                                <Form.Check checked={this.state.proceeded}
                                                                    onChange={this.handleCheckBoxChange}
                                                                    label=""
                                                                    name="proceeded"
                                                                    type="checkbox"
                                                                    onBlur={this.handleBlur}
                                                                />
                                                            </Col>

                                                        </Form.Group>


                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col sm={12} md={6} lg={3}>

                                                <Card >

                                                    <Card.Body>


                                                        <Form.Group as={Row} controlId="proposal" >
                                                            <Form.Label className="text-right" >Proposal</Form.Label>
                                                            
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.proposal}
                                                                    as="textarea"
                                                                    rows="10"
                                                                onBlur={this.handleBlur}
                                                                />
                                                            

                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="notes" >
                                                            <Form.Label  className="text-right" >Notes</Form.Label>
                                                            
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.notes}
                                                                    as="textarea"
                                                                    rows="10"
                                                                onBlur={this.handleBlur}
                                                                bsPrefix="internal"
                                                                />
                                                            

                                                        </Form.Group>

                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col sm={12} md={6} lg={6}>

                                                <Card>
                                                    <Card.Body>
                                                        <h6>Properties</h6>
                                                        <PropertyProposalList
                                                            filter={this.state.propertyFilter}
                                                            isAuthenticated={this.props.isAuthenticated}
                                                            controlType="table2"
                                                            user={this.props.user}
                                                            data={this.state.propertyProposals}
                                                            updateTableState={this.updateTableState}
                                                            saveRecord={this.saveRecord}
                                                            deleteRecord={this.deleteRecord}
                                                            validateRelatedRecord={this.validateRelatedRecord}
                                                            proposalid={this.state.proposal_id}
                                                            areaSum={this.state.areaSum}
                                                        />
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col sm={12} md={6} lg={3}>

                                                {/* <Card id="col3head1"  >
                                                    <Card.Header> Properties </Card.Header>

                                                    <Card.Body>

                                                       
                                                        <PropertyProposalList
                                                            isAuthenticated={this.props.isAuthenticated}
                                                            controlType="list"
                                                            data={this.state.propertyProposals}
                                                            updateTableState={this.updateTableState}
                                                            saveRecord={this.saveRecord}
                                                            deleteRecord={this.deleteRecord}
                                                            propertyid={this.state.property_id}
                                                            propertykey={this.state.property_key}
                                                            proposalid={this.state.proposal_id}
                                                        />

                                                    </Card.Body>
                                                </Card> */}
                                            </Col>


                                    </Form.Row>






                                </Card.Body>
                                </Card>
                            
                              </Tab>
                    

                              <Tab eventKey={2} title="Record History">
                                        <Card style={{ width: '28rem' }}>
                                    <Card.Body>
                                                <Form.Group as={Row} controlId="created_date" >
                                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>Created Date</Form.Label>
                                                    <Col>
                                                        <Form.Control
                                                            value={this.state.created_date!= null ? Moment(this.state.created_date)
                                                                .local()
                                                                .format("DD-MM-YYYY"): ""}
                                                            plaintext readOnly
                                                        />
                                                    </Col>
                                                </Form.Group>

                                                <Form.Group as={Row} controlId="created_by" >
                                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>Created By</Form.Label>
                                                    <Col>
                                                        <Form.Control
                                                            value={this.state.created_by}
                                                            plaintext readOnly
                                                        />
                                                    </Col>
                                                </Form.Group>

                                                <Form.Group as={Row} controlId="last_edited_date" >
                                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>Last Edited Date</Form.Label>
                                                    <Col>
                                                        <Form.Control
                                                            value={this.state.last_edited_date!= null ? Moment(this.state.last_edited_date)
                                                                .local()
                                                                .format("DD-MM-YYYY"): ""}
                                                            plaintext readOnly
                                                        />
                                                    </Col>
                                                </Form.Group>

                                                <Form.Group as={Row} controlId="last_edited_by" >
                                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>Last Edited By</Form.Label>
                                                    <Col>
                                                        <Form.Control
                                                            value={this.state.last_edited_by}
                                                            plaintext readOnly
                                                        />
                                                    </Col>
                                                </Form.Group>

                                    </Card.Body>
                                </Card>

                            </Tab>

                        
                    </Tabs>

                        </Col>

                    </Row>
                   

            
                    
                        
                    </Form>
                
                    </div>

                }
            </div>
        );
    }
}